var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("create-summary") },
            model: {
              value: _vm.settings.CreateSummary,
              callback: function ($$v) {
                _vm.$set(_vm.settings, "CreateSummary", $$v)
              },
              expression: "settings.CreateSummary",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-sortable",
            {
              attrs: {
                tag: "w-list",
                "target-class": "handle",
                items: _vm.settings.Rows,
              },
            },
            [
              _vm._l(_vm.settings.Rows, function (row) {
                return _c(
                  "w-list-item",
                  { key: row.uid, attrs: { "show-handle": "" } },
                  [
                    _vm._l(row.Cols, function (col) {
                      return _c("w-list-item-text", { key: col.uid }, [
                        _vm._v(" " + _vm._s(col.getText(_vm.model)) + " "),
                      ])
                    }),
                    row.Cols.length == 0
                      ? _c("w-list-item-text", [_vm._v("​")])
                      : _vm._e(),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("summary-edit-row"),
                                expression: "$ct('summary-edit-row')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.editRow(row)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("summary-delete-row"),
                                expression: "$ct('summary-delete-row')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.deleteRow(row)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                )
              }),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addRow()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("summary-add-row"))),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.toEditIndex != -1 } },
            [
              _vm.toEditIndex != -1
                ? _c("app-summary-edit-row", {
                    attrs: { model: _vm.model },
                    on: {
                      close: function ($event) {
                        _vm.toEditIndex = -1
                      },
                    },
                    model: {
                      value: _vm.settings.Rows[_vm.toEditIndex],
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Rows, _vm.toEditIndex, $$v)
                      },
                      expression: "settings.Rows[toEditIndex]",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }